import { Skeleton, Stack } from "@mui/material";

export default function DatePickerRangeSkeleton() {
	return (
		<Stack direction={"row"} alignItems={"center"} mt={1}>
			<Skeleton width={150} height={45} className="relative bottom-0" />

			<Skeleton width={150} height={45} sx={{ position: "relative", bottom: "0px" }} className="ml-3" />
		</Stack>
	);
}
